import { render, staticRenderFns } from "./MotivosAtendimento.vue?vue&type=template&id=fa8f2d1a"
import script from "./MotivosAtendimento.vue?vue&type=script&lang=js"
export * from "./MotivosAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports